<template>
  <div class="GenericBigText">
    <div class="bg" :style="bgStyle">
      <div class="container">
        <div :class="['contentWrapper', template ]" :style="contentWrapperStyle">
          <div class="content" v-html="text" :style="textStyle"></div>
          <div class="btnWrapper" v-if="!!btnText">
            <a :target="btnTarget" class="btn" @click="onBtnClick" :href="btnHref" :style="btnStyle">
              <img class="btnIcon" :src="require(`@images/${btnIcon}.svg`)" v-if="!!btnIcon">
              <div class="btnText" v-html="btnText"></div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import '@images/clip.svg'

  export default {
    name: 'GenericBigText',
    data(){
      return {

      }
    },
    components:{
    },
    props: {     
      text: {
        type: String,
        default: ""
      },
      btnStyle: {
        type: Object,
        default: ()=>{}
      },
      btnHref: {
        type: String,
        default: ""
      },
      btnIcon: {
        type: String,
        default: ""
      }, 
      btnTarget: {
        type: String,
        default: ""
      }, 
      btnText: {
        type: String,
        default: ""
      },
      image: {
        type: String,
        default: ""
      },
      template: {
        type: String,
        default: ""
      },
      bgStyle: {
        type: Object,
        default: ()=>{}
      },
      textColor: {
        type: String,
        default: "#000"
      }
    },
    methods: {
      onBtnClick: function(e){
        if(this.btnTarget === '_blank'){
          return true;
        }else{
          e.preventDefault();
          if(e.currentTarget.href.indexOf('#') > -1){
            var event = new CustomEvent('hashClicked', {
              detail: {
                a: e.target
              }
            });
            window.dispatchEvent(event);
          }else{
            window.location.href = e.currentTarget.href;
          }
        }
      }
    },
    computed: {
      contentWrapperStyle(){
        console.log(this.image)
        return {
          backgroundImage: !!this.image ? `url(${this.image})` : null
        }
      },
      //bgStyle(){
      //  return {
      //    backgroundColor: !!this.bgColor ? this.bgColor : 'transparent',
      //    padding: !!this.bgColor ? '150px 0' : '80px 0',
      //  }
      //},
      textStyle(){
        return {
          color: this.textColor
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  @import '~@less/_variables';
  @import '~@less/common';
  @import '~@less/generic_big_text';

</style>
